import {createBrowserRouter} from "react-router-dom";
import SignIn from "../screens/SignIn";
import Players from "../screens/Players";
import api from "../services/api";
import Games from "../screens/Games";
import Game from "../screens/Game";
import NewPlayer from "../screens/NewPlayer";
import Adventures from "../screens/Adventures";
import Play from "../screens/Play";
import Debriefing from "../screens/Debriefing";
import Score from "../screens/Score";

const router = createBrowserRouter([
    {
        path: "/",
        element: <SignIn/>,
    },
    {
        path: "players",
        element: <Players/>,
        loader: async () => api().players(),
    },
    {
        path: "players/new",
        element: <NewPlayer/>,
    },
    {
        path: "games",
        element: <Games/>,
        loader: async () => api().games(),
    },
    {
        path: "adventures",
        element: <Adventures/>,
        loader: async () => api().adventures(),
    },
    {
        path: "games/:id",
        element: <Game/>,
        loader: async ({ request, params }) => api().game(params.id),
    },
    {
        path: "games/:id/score",
        element: <Score/>,
        loader: async ({ request, params }) => api().game(params.id),
    },
    {
        path: "games/:id/play",
        element: <Play/>,
        loader: async ({ request, params }) => api().startGame(params.id),
    },
    {
        path: "games/:id/debriefing",
        element: <Debriefing/>,
        loader: async ({ request, params }) => api().endGame(params.id)
            .then(game => api().survey().then(survey => ({
                game,
                survey
            }))),
    }
]);

export default router;
